export class FetchFeaturedEvents {
  static readonly type = '[FeaturedEvents] Feach Featured Events';
}
